import './module/riccardo-offer';
import deDE from './module/riccardo-offer/snippet/de-DE.json';
import enGB from './module/riccardo-offer/snippet/en-GB.json';

Shopware.Component.register('riccardo-offer-list', () => import('./module/riccardo-offer/page/riccardo-offer-list'));
Shopware.Component.register('riccardo-offer-detail', () => import('./module/riccardo-offer/page/riccardo-offer-detail'));

export { deDE, enGB };
